import { Component, inject } from '@angular/core';
import { RegistryTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RegistryTypeCreateDto,
  RegistryTypeDto,
  RegistryTypeExcelDownloadDto,
  RegistryTypeUpdateDto,
} from '../proxy/planning/dtos/registry-type';
import { REGISTRYTYPE_CONFIG, REGISTRYTYPE_FIELDS } from './registry-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-registry-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RegistryTypeService, ConfirmationService],
  templateUrl: './registry-type.html',
  styleUrl: './registry-type.scss',
})
export class RegistryType extends BaseCrudComponent<
  RegistryTypeDto,
  RegistryTypeCreateDto,
  RegistryTypeUpdateDto,
  RegistryTypeExcelDownloadDto
> {
  service = inject(RegistryTypeService);
  config = REGISTRYTYPE_CONFIG;
  fields = REGISTRYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RegistryTypeDto): RegistryTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RegistryType';
  }
}
